import React from 'react';
import { Button, Grid, Row, Col, Table, Panel } from 'react-bootstrap';

import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { SortIndicator } from '../../../SortIndicator';

import ColumnResize from "react-table-column-resizer";

export class ScheduleGeneratorBase {
    // GETS 
    // ----------------------
    getLayouts(state, onSuccess, onError) {
        state.commands.layouts.list(onSuccess, onError);
    }

    getFolders(state, onSuccess, onError) {
        state.commands.layoutFolders.list(onSuccess, onError);
    }

    groupLayoutsByFolder(layouts, folders) {
        var grouped = {};
        folders.forEach(function(f) { grouped[f.id] = { label: f.name, options: [] }; });
        var unassigned = [];
        layouts.forEach(function(layout) {
            if (layout.folderId && grouped[layout.folderId]) {
                grouped[layout.folderId].options.push(layout);
            } else {
                unassigned.push(layout);
            }
        });
        var result = folders
            .filter(function(f) { return grouped[f.id].options.length > 0; })
            .map(function(f) { return grouped[f.id]; });
        if (unassigned.length > 0) {
            result.push({ label: "Sem pasta", options: unassigned });
        }
        return result;
    }

    getLines(state, onSuccess, onError) {
        state.commands.lines.list(state.edition.network, onSuccess, onError);
    }

    getStops(state, onSuccess, onError) {
        state.commands.stops.listStops(
            state.edition.network,
            state.form.line.id,
            onSuccess,
            onError
        );
    }

    getSetOfDayTypes(state, onSuccess, onError) {
        state.commands.setOfDayTypes.listFull(onSuccess, onError);
    }

    getSchedules(state, onSuccess, onError) {
        state.commands.schedules.list(state.edition.planning, onSuccess, onError);
    }

    // ----------------------

    computeLayoutSelected(state) {
        var data = state.data;
        var form = state.form;
        var validations = state.validations;
        var render = state.render;

        var newRender = {
            tab: render.tab,
            schedules: render.schedules,
            layouts: render.layouts,
            layoutsGrouped: render.layoutsGrouped,
            alternativeText: render.alternativeText,
            setOfDayTypes: [],
            schedulesComponents: [],
            notesComponents: render.notesComponents
        };

        if (!form.layout) {
            return { render: newRender };
        }

        if (form.layout.id === -1 || form.layout.id === -2) {
            newRender.tab = 1;
            return { render: newRender };
        }

        var setOfDayTypesCustomObjects = [];

        var layoutDayTimesheetComponents = form.layout.components
            .filter(function(comp) {
                return validations.schedulesComponents.indexOf(comp.type) !== -1;
            });

        layoutDayTimesheetComponents.forEach(function(comp) {
            if (!comp.dataIdentifier) {
                return;
            }

            var componentId = comp.id;

            // A component asks for each set of day types once. A stored dataIdentifier can still
            // repeat one (it is written separately from the component configuration and the two can
            // drift apart), which would show the same day type block several times in this tab.
            var seenSetOfDayTypesIds = [];
            var dataIdentifierNumbers = comp.dataIdentifier.split('|%|')[0]
                .split(',')
                .map(function(id) { return parseInt(id, 10); })
                .filter(function(id) {
                    if (isNaN(id) || seenSetOfDayTypesIds.indexOf(id) !== -1) {
                        return false;
                    }

                    seenSetOfDayTypesIds.push(id);
                    return true;
                });

            var configuration = undefined;
            if (comp.configuration !== undefined && comp.configuration !== null) {
                configuration = JSON.parse(comp.configuration);
            }

            const hasDayGroup = configuration !== undefined && configuration !== null
                && configuration["dayGroups"] !== undefined && configuration["dayGroups"] !== null;

            if (
                configuration === undefined ||
                configuration === null ||
                (!hasDayGroup && (undefined === configuration.descriptionPt || null === configuration.descriptionPt || "" === configuration.descriptionPt))
            ) {
                configuration = { descriptionPt: "Sem descrição" };
            }

            let idx = 0;
            dataIdentifierNumbers.forEach(function(dataIdentifierId) {
                setOfDayTypesCustomObjects.push({ componentId: componentId, setOfDayTypesId: dataIdentifierId });

                var subsets = this.getSetOfDayTypesSubsets(data.setOfDayTypes, dataIdentifierId);
                var dayGroup = hasDayGroup ? configuration["dayGroups"][idx] : null;

                newRender.schedulesComponents.push({
                    componentId: componentId,
                    setOfDayTypesId: dataIdentifierId,
                    subsets: subsets,
                    schedules: [],
                    dayGroup: dayGroup || null,
                    description: dayGroup ? dayGroup.descriptionPt : configuration.descriptionPt,
                    index: idx
                });
                idx++;
            }.bind(this));
        }.bind(this));

        setOfDayTypesCustomObjects.forEach(function(set) {
            var setOfDayTypesObj = data.setOfDayTypes.find(function(dT) { return dT.id === set.setOfDayTypesId; });
            if (setOfDayTypesObj === undefined) {
                return;
            }

            newRender.setOfDayTypes.push(setOfDayTypesObj);

            newRender.schedulesComponents
                .filter(function(component) {
                    return component.componentId === set.componentId && component.setOfDayTypesId === set.setOfDayTypesId;
                })
                .forEach(function(component) {
                    component.setOfDayTypes = setOfDayTypesObj;
                    component.schedules = data.schedules.filter(function(sched) {
                        return sched.setOfDayTypes !== undefined && (
                            sched.setOfDayTypes.id === set.setOfDayTypesId ||
                            component.subsets.indexOf(sched.setOfDayTypes.id) !== -1
                        );
                    });
                });
        });

        newRender.notesComponents = form.layout.components
            .filter(function(comp) { return comp.type === 'Notes'; })
            .map(function(comp) { return Object.assign({ notes: "" }, comp); });

        return { render: newRender };
    }

    computeFilteredSchedules(state) {
        var form = state.form;
        var data = state.data;
        var render = state.render;

        var newRender = Object.assign({}, render);

        if (form.line === undefined) {
            newRender.schedules = [];
            return { render: newRender };
        }

        var filtered = {};
        Object.keys(data.carrisSchedules).forEach(function(dayType) {
            var schedules = data.carrisSchedules[dayType].filter(function(schedule) {
                return Array.isArray(schedule.lines) && schedule.lines.indexOf(form.line.id) !== -1;
            });
            if (schedules.length > 0) {
                filtered[dayType] = schedules;
            }
        });

        newRender.schedules = filtered;
        return { render: newRender };
    }

    computeSelectionExists(state, fullUpdate) {
        var data = state.data;
        var providerSelections = state.providerSelections;
        var render = state.render;

        if (!providerSelections.search) {
            return null;
        }

        var newForm = Object.assign({}, state.form);

        if (fullUpdate) {
            newForm.layout = data.layouts.find(function(layout) {
                return providerSelections.data.layout !== undefined &&
                    providerSelections.data.layout !== null &&
                    layout.id === providerSelections.data.layout.id;
            });
            newForm.line = data.lines.find(function(line) {
                return line.code === providerSelections.data.line;
            });
        }

        var selection = this.checkIfSgsExists(providerSelections, newForm);

        if (selection !== undefined) {
            if (selection.stopsSched && Array.isArray(data.stops) && newForm.type === 1) {
                newForm.stops = selection.stops
                    .map(function(stop) {
                        return data.stops.find(function(e) { return e.code === stop.code; });
                    })
                    .filter(Boolean);
            }

            if (!newForm.line) {
                return null;
            }

            if (newForm.layout && newForm.layout.id === -1) {
                // Legacy layout: flat array of schedule IDs
                newForm.schedules = [];
                selection.componentSchedules.forEach(function(component) {
                    newForm.schedules = newForm.schedules.concat(component.schedules);
                });
            } else {
                // Normal layout: schedules keyed by component
                newForm.schedules = {};
                selection.componentSchedules.forEach(function(sched) {
                    var schedComp = render.schedulesComponents.find(function(component) {
                        if (component.componentId !== sched.componentId) return false;
                        if (sched.index !== undefined && component.index !== sched.index) return false;
                        return true;
                    });
                    if (!schedComp) {
                        return;
                    }
                    var objKey = newForm.line.code + "§" + sched.componentId + "§" + newForm.type + "§" + schedComp.setOfDayTypesId + "§" + schedComp.index;
                    newForm.schedules[objKey] = sched.schedules.slice();
                });

                // Remove schedule entries that no longer exist in render
                Object.keys(newForm.schedules).forEach(function(objKey) {
                    var keyParts = objKey.split('§');
                    var parsedComponentId = parseInt(keyParts[1], 10);
                    var parsedIndex = keyParts.length > 4 ? parseInt(keyParts[4], 10) : 0;

                    var comp = (render.schedulesComponents || []).find(function(c) {
                        return c.componentId === parsedComponentId && c.index === parsedIndex;
                    });

                    if (!comp) {
                        delete newForm.schedules[objKey];
                        return;
                    }

                    var allowedIds = (comp.schedules || []).map(function(s) { return s.id; });
                    newForm.schedules[objKey] = (newForm.schedules[objKey] || []).filter(function(id) {
                        return allowedIds.indexOf(id) !== -1;
                    });

                    if (!newForm.schedules[objKey] || newForm.schedules[objKey].length === 0) {
                        delete newForm.schedules[objKey];
                    }
                });

                if (selection.layoutNotes) {
                    var newNotesComponents = render.notesComponents.map(function(n) { return Object.assign({}, n); });
                    selection.layoutNotes.forEach(function(note) {
                        var found = newNotesComponents.find(function(i) { return i.id === note.componentId; });
                        if (found !== undefined) {
                            found.notes = note.text;
                        }
                    });
                    var newRender = Object.assign({}, render, { notesComponents: newNotesComponents });
                    return { form: newForm, render: newRender };
                }
            }
        } else {
            newForm.stops = [];
            newForm.schedules = (newForm.layout && newForm.layout.id === -1) ? [] : {};
            var clearedNotes = render.notesComponents.map(function(n) { return Object.assign({}, n, { notes: '' }); });
            var clearedRender = Object.assign({}, render, { notesComponents: clearedNotes });
            return { form: newForm, render: clearedRender };
        }

        return { form: newForm };
    }

    computeProviderSelectionsPayload(state) {
        var providerSelections = state.providerSelections;
        var form = state.form;
        var render = state.render;

        var data = Object.assign({}, providerSelections.data);

        data.stopsSched = form.type === 1;
        data.referenceDate = form.referenceDate;
        data.line = form.line.code;
        data.layout = form.layout;
        data.frequency = form.frequency !== undefined ? form.frequency : 0;
        data.version = form.version !== undefined ? form.version : "";

        if (form.complementaryLines !== undefined) {
            data.complementaryLines = form.complementaryLines.map(function(line) { return line.code; });
        }

        var found = data.scheduleGenerationSelections.findIndex(function(i) {
            return i.line === data.line &&
                i.layout === data.layout.id &&
                i.stopsSched === data.stopsSched;
        });

        var componentSchedules = [];
        for (var objKey in form.schedules) {
            var keyParts = objKey.split('§');
            var parsedComponentId = parseInt(keyParts[1], 10);
            var parsedIndex = keyParts.length > 4 ? parseInt(keyParts[4], 10) : undefined;

            if (isNaN(parsedComponentId)) {
                continue;
            }
            componentSchedules.push({
                id: 0,
                componentId: parsedComponentId,
                index: isNaN(parsedIndex) ? 0 : parsedIndex,
                schedules: form.schedules[objKey]
            });
        }
        componentSchedules.sort(function(a, b) { return a.componentId - b.componentId; });
        componentSchedules.forEach(function(c) {
            c.schedules.sort(function(a, b) { return a.scheduleId - b.scheduleId; });
        });

        var layoutNotes = render.notesComponents.map(function(n) {
            return { id: 0, componentId: n.id, text: n.notes };
        });
        layoutNotes.sort(function(a, b) { return a.componentId - b.componentId; });

        var generationSelections = {
            stops: [],
            stopsSched: data.stopsSched,
            line: form.line.code,
            layout: form.layout.id,
            componentSchedules: componentSchedules,
            referenceDate: form.referenceDate,
            layoutNotes: layoutNotes
        };

        if (form.complementaryLines !== undefined) {
            generationSelections.complementaryLines = form.complementaryLines.map(function(line) { return line.code; });
        }

        if (data.stopsSched) {
            form.stops.forEach(function(s) {
                generationSelections.stops.push({ id: 0, code: s.code });
            });
        }
        generationSelections.stops.sort(function(a, b) { return a.code - b.code; });

        if (found === -1) {
            data.scheduleGenerationSelections.push(generationSelections);
        } else {
            generationSelections.id = data.scheduleGenerationSelections[found].id;
            this.mergeSelectionStops(data, generationSelections, found);
            this.mergeSelectionSchedules(data, generationSelections, found);
            this.mergeSelectionLayoutNotes(data, generationSelections, found);
            data.scheduleGenerationSelections[found] = generationSelections;
        }

        return data;
    }

    // MERGE HELPERS
    // ----------------------

    mergeSelectionStops(providerSelections, newSelection, sgsPosition) {
        newSelection.stops.forEach(function(stop) {
            var found = providerSelections.scheduleGenerationSelections[sgsPosition].stops.find(function(i) {
                return i.code === stop.code;
            });
            if (found !== undefined) {
                stop.id = found.id;
            }
        });
    }

    mergeSelectionSchedules(providerSelections, newSelection, sgsPosition) {
        var existing = providerSelections.scheduleGenerationSelections[sgsPosition].componentSchedules;

        existing.forEach(function(sched) {
            var index = newSelection.componentSchedules.findIndex(function(i) {
                return i.componentId === sched.componentId;
            });
            if (index !== -1) {
                newSelection.componentSchedules[index].id = sched.id;
            }
        });

        var schedsToDelete = existing.filter(function(component) {
            return newSelection.componentSchedules.findIndex(function(cs) {
                return cs.componentId === component.componentId;
            }) === -1;
        });

        if (schedsToDelete.length !== 0) {
            providerSelections.scheduleGenerationSelections[sgsPosition].componentSchedules =
                existing.filter(function(s) {
                    return schedsToDelete.findIndex(function(sd) { return sd.componentId === s.componentId; }) === -1;
                });
        }
    }

    mergeSelectionLayoutNotes(providerSelections, newSelection, sgsPosition) {
        var existing = providerSelections.scheduleGenerationSelections[sgsPosition].layoutNotes;

        existing.forEach(function(note) {
            var index = newSelection.layoutNotes.findIndex(function(i) {
                return i.componentId === note.componentId;
            });
            if (index !== -1) {
                newSelection.layoutNotes[index].id = note.id;
            }
        });

        var notesToDelete = existing.filter(function(note) {
            return newSelection.layoutNotes.findIndex(function(n) {
                return n.componentId === note.componentId;
            }) === -1;
        });

        if (notesToDelete.length !== 0) {
            providerSelections.scheduleGenerationSelections[sgsPosition].layoutNotes =
                existing.filter(function(n) {
                    return notesToDelete.findIndex(function(nd) { return nd.componentId === n.componentId; }) === -1;
                });
        }
    }

    updateSelectionStops(providerSelections, newSelection, sgsPosition) {
        this.mergeSelectionStops(providerSelections, newSelection, sgsPosition);
    }

    updateSelectionSchedules(providerSelections, newSelection, sgsPosition) {
        this.mergeSelectionSchedules(providerSelections, newSelection, sgsPosition);
    }

    updateSelectionLayoutNotes(providerSelections, newSelection, sgsPosition) {
        this.mergeSelectionLayoutNotes(providerSelections, newSelection, sgsPosition);
    }

    // HELPERS
    // ----------------------

    checkIfSgsExists(providerSelections, form) {
        if (!providerSelections.search || form.line === undefined || form.layout === undefined) {
            return undefined;
        }

        var sgs = providerSelections.data.scheduleGenerationSelections;

        return sgs.find(function(i) {
            return i.line === form.line.code &&
                i.layout === form.layout.id &&
                i.stopsSched === (form.type === 1);
        });
    }

    getSetOfDayTypesSubsets(setOfDayTypes, setOfDayTypesId) {
        var selectedSetOfDayTypes = setOfDayTypes.find(function(dT) { return dT.id === setOfDayTypesId; });
        var subsets = [];

        if (selectedSetOfDayTypes !== undefined) {
            setOfDayTypes.forEach(function(set) {
                if (setOfDayTypesId !== set.id) {
                    var dayTypes = set.dayTypes;
                    var output = false;

                    dayTypes.forEach(function(dayType) {
                        output = output || (undefined !== selectedSetOfDayTypes.dayTypes.find(function(setDayType) {
                            return setDayType.id === dayType.id;
                        }));
                    });

                    if (output) {
                        subsets.push(set.id);
                    }
                }
            });
        }

        return subsets;
    }

    getScheduleClassName(form, componentId, schedule, setOfDayTypesId, index) {
        if (form.line === undefined) {
            return "";
        }

        var objKey = form.line.code + "§" + componentId + "§" + form.type + "§" + setOfDayTypesId + "§" + index;
        if (form.schedules[objKey] === undefined) {
            return "";
        }

        return form.schedules[objKey].find(function(s) { return s === schedule.id; }) === undefined
            ? ""
            : "checked";
    }

    filterAllowedSchedules(state, componentId, objKey) {
        var render = state.render;
        var form = state.form;

        for (const schedIndex in render.schedulesComponents) {
            if (render.schedulesComponents[schedIndex].componentId !== componentId) {
                continue;
            }

            form.schedules[objKey] = form.schedules[objKey].reduce(function(output, schedId) {
                var filteredSchedules = render.schedulesComponents[schedIndex].schedules
                    .filter(function(schedule) { return schedule.id === schedId; })
                    .map(function(schedule) { return schedule.id; });

                if (filteredSchedules.length !== 0) {
                    filteredSchedules.forEach(function(id) { output.push(id); });
                }

                return output;
            }, []);
        }
    }

    findSgsPosition(providerSelections, newSelection) {
        for (var i = 0; i < providerSelections.scheduleGenerationSelections.length; i++) {
            if (providerSelections.scheduleGenerationSelections[i].stops.length === newSelection[0].stops.length) {
                const stopCodes = [];
                const newlayoutComponentIds = [];
                const existinglayoutComponentIds = [];

                providerSelections.scheduleGenerationSelections[i].stops.forEach(function(s2) { stopCodes.push(s2.code); });
                providerSelections.scheduleGenerationSelections[i].layoutNotes.forEach(function(ln) { existinglayoutComponentIds.push(ln.componentId); });
                newSelection[0].layoutNotes.forEach(function(ln) { newlayoutComponentIds.push(ln.componentId); });

                if (
                    JSON.stringify(stopCodes) === JSON.stringify(newSelection[0].stops) &&
                    JSON.stringify(existinglayoutComponentIds) === JSON.stringify(newlayoutComponentIds)
                ) {
                    return i;
                }
            }
        }

        return -1;
    }

    // SORT
    // ----------------------

    sort(first, second, sort) {
        var a = first[sort.column];
        var b = second[sort.column];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            return sort.order === "ascending" ? 1 : -1;
        } else if (b === undefined) {
            return sort.order === "ascending" ? -1 : 1;
        }

        if (sort.order === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    // RENDERS
    // ----------------------

    renderOrientationLabel(orientation) {
        switch (orientation) {
            case 'C': return "Circular";
            case 'R': return "Volta";
            case 'G': return "Ida";
            case undefined: return "Não Definido";
            default: return "Ambos";
        }
    }

    renderSetOfDayTypesLabel(setOfDayTypes, component) {
        if (setOfDayTypes === undefined) {
            return null;
        }

        return (
            <div className="margin-top-15 padding-top-7">
                <div className="control-label">{setOfDayTypes.name}</div>
                <div>{component.description}</div>
            </div>
        );
    }

    renderEditionLoadingFeedback(isLoadingEdition) {
        return (
            <HandleMessage
                title="A Carregar a Edição..."
                message={<LoadingSpinner />}
                // eslint-disable-next-line react/style-prop-object
                style="primary"
                icon="transfer"
                show={isLoadingEdition}
                small
                noButtons />
        );
    }

    renderGeneratingFeedback(isGenerating) {
        return (
            <HandleMessage
                title="A Gerar..."
                message={<LoadingSpinner />}
                // eslint-disable-next-line react/style-prop-object
                style="primary"
                icon="transfer"
                show={isGenerating}
                small
                noButtons />
        );
    }

    renderSchedule(edition, form, component, schedule, index, onScheduleRowClick) {
        return (
            <tr key={"sched-" + schedule.id}
                className={"busched selectable " + this.getScheduleClassName(form, component.componentId, schedule, component.setOfDayTypesId, component.index)}
                onClick={function() { onScheduleRowClick(form, schedule, component.componentId, component.setOfDayTypesId, component.index); }}>
                <td>{schedule.name}</td>
                <td colSpan={2}>{edition.getPlanningEditionName(schedule.planningEdition)}</td>
            </tr>
        );
    }

    renderComponentSchedules(edition, form, component, onScheduleRowClick) {
        var componentLineSchedules = component.schedules
            .filter(function(schedule) { return schedule.lines.indexOf(form.line.id) !== -1; });

        if (!componentLineSchedules || componentLineSchedules.length === 0) {
            return (
                <tr className="busched">
                    <td colSpan={3}>
                        <span>Sem horários disponíveis para selecionar</span>
                    </td>
                </tr>
            );
        }

        return (
            <React.Fragment>
                {componentLineSchedules.map(function(schedule, index) {
                    return this.renderSchedule(edition, form, component, schedule, index, onScheduleRowClick);
                }.bind(this))}
            </React.Fragment>
        );
    }

    renderStopsTab(state, onSortChange, onSelectAllStops, onStopRowClick) {
        var form = state.form;
        var data = state.data;
        var sort = state.sort;
        var actions = state.actions;

        if (form.type === 2) {
            return null;
        }

        if (actions.isLoadingStops) {
            return <LoadingSpinner />;
        }

        return (
            <Table responsive striped hover>
                <thead>
                    <tr>
                        <th onClick={function() { onSortChange('code'); }}>
                            Código {sort.column === "code" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                        </th>
                        <ColumnResize className="columnResizer" />
                        <th onClick={function() { onSortChange('name'); }}>
                            Nome {sort.column === "name" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                        </th>
                        <ColumnResize className="columnResizer" />
                        <th onClick={function() { onSortChange('orientation'); }}>
                            Orientação {sort.column === "orientation" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                        </th>
                        <ColumnResize className="columnResizer" />
                        <th>Na Espinha</th>
                        <ColumnResize className="columnResizer" />
                        <th>
                            <Button bsSize="small" className="pull-right" onClick={onSelectAllStops}>SELECIONAR TUDO</Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data.stops.sort(function(a, b) { return this.sort(a, b, sort); }.bind(this)).map(function(stop, idx) {
                        return (
                            <tr key={"stop-" + stop.code}
                                className={"busched selectable " + (form.stops.findIndex(function(s) { return s.code === stop.code; }) !== -1 ? "checked" : "")}
                                onClick={function() { onStopRowClick(stop); }}>
                                <td>{stop.code !== 'undefined' ? stop.code : ''}</td>
                                <td className="column_resizer_body" />
                                <td>{stop.name !== 'undefined' ? stop.name : ''}</td>
                                <td className="column_resizer_body" />
                                <td className="padding-left-25">{this.renderOrientationLabel(stop.orientation)}</td>
                                <td className="column_resizer_body" />
                                <td className="padding-left-35" colSpan={2}>{stop.inSpine ? '✔' : ''}</td>
                                <td className="column_resizer_body" />
                            </tr>
                        );
                    }.bind(this))}
                </tbody>
            </Table>
        );
    }

    renderSchedulesTab(state, onSelectAllSchedules, onScheduleRowClick) {
        var form = state.form;
        var render = state.render;
        var edition = state.edition;

        if (form.line === undefined) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading><Panel.Title> Atenção </Panel.Title></Panel.Heading>
                    <Panel.Body>Linha não selecionada</Panel.Body>
                </Panel>
            );
        }

        if (form.layout === undefined) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading><Panel.Title> Atenção </Panel.Title></Panel.Heading>
                    <Panel.Body>Layout não selecionado</Panel.Body>
                </Panel>
            );
        }

        if (render.schedulesComponents.length === 0 || render.setOfDayTypes.length === 0) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading><Panel.Title> Atenção </Panel.Title></Panel.Heading>
                    <Panel.Body>Tipos de dia não configurados no Layout</Panel.Body>
                </Panel>
            );
        }

        return (
            <div>
                {render.schedulesComponents.map(function(component) {
                    return (
                        <Grid key={"day-type-schedules-" + component.componentId + "-" + component.index} fluid>
                            <Row>
                                <Col sm={2}>
                                    {this.renderSetOfDayTypesLabel(component.setOfDayTypes, component)}
                                </Col>
                                <Col sm={10} className="table-small-screens">
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th className="width-70p">Nome</th>
                                                <th className="width-30p">Edição</th>
                                                <th>
                                                    <Button
                                                        bsSize="small"
                                                        bsStyle="default"
                                                        className="pull-right"
                                                        onClick={function() { onSelectAllSchedules(component, component.setOfDayTypesId); }}>
                                                        SELECIONAR TUDO
                                                    </Button>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderComponentSchedules(edition, form, component, onScheduleRowClick)}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Grid>
                    );
                }.bind(this))}
            </div>
        );
    }
}